import React from 'react';
import { Chip } from '@infoods/lifebase-ui';

type ActivationStatusChipProps = {
  active: boolean | undefined;
};

const ActivationStatusChip = ({ active }: ActivationStatusChipProps) => {
  return active ? (
    <Chip label="active" size="extraSmall" color="success" />
  ) : (
    <Chip label="inactive" size="extraSmall" color="default" />
  );
};

export { ActivationStatusChip };
